import React from 'react';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Divider,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  section: {
    alignItems: 'center',
    display: 'flex',
    minHeight: '96px',
    padding: theme.spacing(0, 3.5, 0, 3.5)
  },
}));

const TopSection = (props) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.section}>
        {props.children}
      </div>
      <Divider />
    </>
  );
};

TopSection.propTypes = {
  children: PropTypes.node
};

export default TopSection;
